import { cx } from '@mage-ui/styled-system/css';
import { imageRound } from '@mage-ui/styled-system/recipes';

export const ImageRound = ({ src, alt, sizes, onError, className }) => {
	if (!src) {
		return null;
	}

	return (
		<img
			src={src}
			alt={alt ?? ''}
			width={sizes.width}
			height={sizes.height}
			className={cx(imageRound(), className)}
			onError={onError}
		/>
	);
};
